var app = angular.module('leonardo');

var LagType = function (TemplateService) {
  return function (item) {
    if (item && (item.lag_type !== null) && (item.lag_type !== undefined) && (item.lag_type !== ''))
      switch (item.lag_type.toString()) {
        case TemplateService.TYPE_LAG_SS:
          return 'SS';
        case TemplateService.TYPE_LAG_FS:
          return 'FS';
      }
    return '';
  }
};

app.filter('lagType', ['TemplateService', LagType]);
